export default {
  "General": "22214819", 
  "Appraisals": "23750536", 
  "Appraisals - invalid code": "23750536", 
  "Order Cancellation": "24992286", 
  "Missing Orders/Items": "360000005023", 
  "Payments": "24992286", 
  "Orders": "23750516", 
  "Scent Quality": "22214819", 
  "Damaged Products": "24944963", 
  "Website Quality": "22214819", 
  "Feedback": "22214819", 
  "PR / Sponsorships": "22214819",
  "Duplicated Jewelry": "360000455463",
  "ShippingTracking": "360000449646",
  "Contests": "25595203"
}